// extracted by mini-css-extract-plugin
export default {"cancelModalContent":"style_cancelModalContent__d9vjw","cancelModalButtons":"style_cancelModalButtons__ynJB+"};